<template>
  <div class="order-list">
    <el-card class="query-card">

      <el-form
        :model="UnNormalProcessAddReqVO"
        :rules="rules"
        ref="UnNormalProcessAddReqVO"
        label-width="200px"
        size="small"
      >

        <!-- 流水订单号 -->
        <el-form-item :label="$t('forwardRefundmentList.tradeNo')" prop="upTrNo">
          <el-input
            v-model="UnNormalProcessAddReqVO.upTrNo"
            :placeholder="$t('forwardRefundmentList.tradeNo_fv_of')"
            clearable
            style="width: 430px"
          />
          <el-button
            type="primary"
            size="small"
            style="margin-left:10px"
            @click="queryOrder"
          >
            {{$t('query')}}
          </el-button>
        </el-form-item>


        <el-card
          v-if="orderInfo"
          shadow="never"
          class="order-info-card"
        >
          <el-descriptions
            :column="2"
            border
            size="small"
          >
            <el-descriptions-item :label="$t('forwardRefundmentList.tradeAmount')">
              {{ orderInfo.trAmount }} {{ orderInfo.currency }}
            </el-descriptions-item>

            <el-descriptions-item :label="$t('forwardRefundmentList.canbackamount')">
      <span style="color:#F56C6C;font-weight:bold">
        {{ orderInfo.refundableAmount }} {{ orderInfo.currency }}
      </span>
            </el-descriptions-item>

            <el-descriptions-item :label="$t('forwardRefundmentList.merOrderNO')">
              {{ orderInfo.trMerOrderno }}
            </el-descriptions-item>

            <el-descriptions-item :label="$t('forwardRefundmentList.gwNo')">
              {{ orderInfo.trGwNo }}
            </el-descriptions-item>
          </el-descriptions>
        </el-card>


        <!-- 退款方式 -->
        <el-form-item
          v-if="orderInfo && orderInfo.isPartRefund === 1"
          :label="$t('forwardRefundmentList.refundtype')"
          prop="refundType"
        >
          <el-radio-group
            v-model="UnNormalProcessAddReqVO.refundType"
          >
            <el-radio label="ALL">
              {{$t('forwardRefundmentList.allrefund')}}
            </el-radio>

            <el-radio label="PART">
              {{$t('forwardRefundmentList.litrefund')}}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 退款金额 -->
        <el-form-item :label="$t('forwardRefundmentList.refundamount')" prop="refundAmount">
          <el-input
            v-model="UnNormalProcessAddReqVO.refundAmount"
            @input="handleAmountInput"
            :disabled="
            UnNormalProcessAddReqVO.refundType === 'ALL'
          "
            clearable
            style="width: 430px"
            :placeholder="$t('forwardRefundmentList.refundamount_iv_oe')"
          />

          {{ orderInfo ? orderInfo.currency : '' }}
        </el-form-item>

        <!-- 退款原因 -->
        <el-form-item :label="$t('forwardRefundmentList.refundreason')" prop="refundReason">
          <el-input
            type="textarea"
            :rows="4"
            v-model="UnNormalProcessAddReqVO.refundReason"
            :placeholder="$t('forwardRefundmentList.refundReason_iv_oe')"
          />
        </el-form-item>

        <!-- 按钮 -->
        <el-form-item>
          <el-button
            type="primary"
            @click="submitRefund"
          >
            {{ $t('forwardRefundmentList.submitRefund') }}
          </el-button>

          <el-button @click="resetForm">
            {{$t('reset')}}
          </el-button>
        </el-form-item>

      </el-form>

    </el-card>
  </div>
</template>

<script>

export default {
  name: "OrderList",
  data() {
    return {
      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.SysMerOperatelogReqVo.startTime) {
            return false;
          }

          return (
            time.getTime() <
            new Date(this.SysMerOperatelogReqVo.startTime).getTime()
          );
        }
      },
      loading: false,
      refundIsCheck: null,
      UnNormalProcessAddReqVO: {
        upTrNo: '',          // 流水订单号
        refundType: '',   // ALL=全部退款 PART=部分退款
        refundAmount: '',    // 退款金额
        refundReason: ''     // 退款原因
      },
      orderInfo: null,

      loadingOrder: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",

    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    //this.setDefaultTime(); //时间设置
  },
  mounted() {
  /*  this.$nextTick(() => {
      this.initColumnWidths();
    });*/
  },
  // 发送变化重新计算
  computed:{
    rules() {
      const validateRefundAmount = (rule, value, callback) => {
        if (!value && value !== 0) {
          return callback(new Error(this.$t('forwardRefundmentList.refundamount_iv_oe')));
        }

        const amount = Number(value);


        if (isNaN(amount) || amount <= 0) {
          return callback(new Error(this.$t('forwardRefundmentList.refundAmount')));
        }

        // ② 不能超过可退款金额
        if (this.orderInfo && amount > Number(this.orderInfo.refundableAmount)) {
          return callback(
              this.$t('forwardRefundmentList.refundAmountCom', {
                amount: this.orderInfo.refundableAmount,
                currency: this.orderInfo.currency
              })

          );
        }

        callback();
      };

      return {
        upTrNo: [
          { required: true, message: this.$t('forwardRefundmentList.tradeNo_fv_of'), trigger: 'blur' }
        ],
        refundAmount: [
          { required: true, validator: validateRefundAmount, trigger: 'blur' }
        ],
        refundReason: [
          { required: true, message: this.$t('forwardRefundmentList.refundReason_iv_oe'), trigger: 'blur' }
        ]
      };
    }
  },
  watch: {
    'UnNormalProcessAddReqVO.refundType'(val) {
      if (!this.orderInfo) return

      if (val === 'ALL') {
        this.UnNormalProcessAddReqVO.refundAmount =
            this.orderInfo.refundableAmount
      } else {
        this.UnNormalProcessAddReqVO.refundAmount = ''
      }
    }
  },
  methods: {
    async submitRefund() {
      this.$refs.UnNormalProcessAddReqVO.validate(async valid => {
        if (!valid) {
          return false;
        }
      const params = {
        upTrNo: this.UnNormalProcessAddReqVO.upTrNo || undefined,
        refundAmount: this.UnNormalProcessAddReqVO.refundAmount || undefined,
        refundReason: this.UnNormalProcessAddReqVO.refundReason || undefined,

      }


      const res = await this.$axios.post(
        '/api/unnormal/add',
        params
      )

      if (res.data.code === 0) {

        this.$message.success(res.data.msg)
        this.resetForm()
        this.orderInfo = null
      } else {

        this.$message.error(res.data.msg)
      }
      });

    },

    handleAmountInput(val) {
      this.UnNormalProcessAddReqVO.refundAmount =
        val.replace(/[^\d.]/g, '')
          .replace(/(\..*)\./g, '$1')
          .replace(/^(\d+\.\d{0,2}).*$/, '$1')
    },

    resetForm() {
      this.$refs.UnNormalProcessAddReqVO.resetFields()
    },



    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();
      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async queryOrder() {
      if (!this.UnNormalProcessAddReqVO.upTrNo) {
        this.$message.warning(this.$t('please_inputOrder'))
        return
      }

      this.loading = true

      try {
        const res = await this.$axios.get(
          '/api/unnormal/getRefundInfo',
          {
            params: {
              upTrNo: this.UnNormalProcessAddReqVO.upTrNo
            }
          }
        )

        if (res.data.code === 0) {
          const data = res.data.data

          this.orderInfo = {
            trAmount: data.tradeamount,
            trMerOrderno: data.mererOrderno,
            trGwNo: data.gwNoName,
            refundableAmount: data.canbackamount,
            currency: data.currency,
            isPartRefund: data.ispartredunt
          }

          // 如果只支持全额退款
          if (data.ispartredunt === 0) {
            // 不支持部分退款
            this.UnNormalProcessAddReqVO.refundType = 'ALL'
          }else {
            this.UnNormalProcessAddReqVO.refundType = 'ALL'
          }
          // 自动带出金额
          this.UnNormalProcessAddReqVO.refundAmount =
            data.canbackamount

          // 币种
          this.UnNormalProcessAddReqVO.currency =
            data.currency

        } else {
          this.orderInfo = null
          this.$message.error(res.data.msg)
        }
      } catch (err) {
        console.error(err)
        this.orderInfo = null
        this.$message.error(this.$t('requestFailed'))
      } finally {
        this.loading = false
      }
    },
    // 表头宽度
    initColumnWidths() {
      const cols = [
        "tradeNo",
        "merOrderNO",
        "mercheckStatus",
        "refundamount",
        "refundreason",
        "processstatus",
        "operater",
        "refundtime",
        "processtime",
        "tradingTime",
        "returnurl",
        "website",
        "email",

      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `UnNormalProcessAddReqVO.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 120px;
  text-align: right;
}


/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.drawer-form {
  padding-right: 20px;
}

/*侧边弹窗*/
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 15px 20px;

  border-top: 1px solid #ebeef5;
  background: #fff;

  text-align: right;
}
::v-deep .el-drawer__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.drawer-form {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 80px;
}
.drawer-footer {
  flex-shrink: 0;
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
  background: #fff;
  text-align: right;
}




</style>



// WEBPACK FOOTER //
// src/view/refundment/forwardRefundAdd.vue